import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { TFTooltipFabric } from './adapter.fabric';
/** Thin shell, no vendor import — at migration, only this import line changes. */ var TFTooltip = function TFTooltip(props) {
    return /*#__PURE__*/ _jsx(TFTooltipFabric, _object_spread({}, props));
};
export default TFTooltip;
